(function () {
    'use strict';
    
    angular
    .module('szallodak-seo', []);
})();
